import { makeStyles } from 'tss-react/mui';

export const useColorButtonStyles = makeStyles()((theme) => ({
  button: {
    borderRadius: '100%',
    border: `1.5px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(0.25),
  },
  colorOrImage: {
    flexShrink: 0,
    borderRadius: '100%',
    width: 12,
    height: 12,
    backgroundClip: 'content-box',
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  selected: {
    border: `1.5px solid ${theme.palette.custom.teceo.orange}`,
  },
}));
